import { render, staticRenderFns } from "./DesmatamentoInfonaParaguai.vue?vue&type=template&id=7ea081f5&lang=pug"
import script from "./DesmatamentoInfonaParaguai.vue?vue&type=script&lang=js"
export * from "./DesmatamentoInfonaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports